export default __webpack_public_path__ + "static/media/CardHoverIcon.327a9f40.svg";